module.exports = __webpack_public_path__ + "portal-static/img/图标2.894b4d85.png";